import { request, queryString } from '../util'

const headers = { 'Content-Type': 'application/json' }
const url = '/private/api/clientleaves'

// TODO: JVP to be deprecated
export default {
  add (values) {
    return request(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(values)
    })
  },
  get (id) {
    return request(`${url}/${id}`)
  },

  getByClient (cid) {
    return request(`${url}/client/${cid}`)
  },

  getByStartEnd (clientId, start, end) {
    return request(`${url}/clientId/${clientId}/startD/${start}/endD/${end}`)
  },

  remove (id) {
    return request(`${url}/${id}`, {
      method: 'DELETE',
      headers
    })
  },
  save (id, values) {
    return request(`${url}/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(values)
    })
  },
  listByPage (page, size, filter, sorting, text) {
    return request(`${url}/page/${page}/size/${size}${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  },
  getSuburbs () {
    return request(`${url}/suburbs`)
  },
  getClientIds () {
    return request(`${url}/ids`)
  },
  listImpactedJobsByPage (page, size, filter, sorting, text) {
    return request(`${url}/jobs/page/${page}/size/${size}${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  },
  updateJobsUFN (values) {
    return request(`${url}/ufn`, {
      method: 'POST',
      headers,
      body: JSON.stringify(values)
    })
  },
  updateJobsUndoUFN (values) {
    return request(`${url}/undo/ufn`, {
      method: 'POST',
      headers,
      body: JSON.stringify(values)
    })
  }
}
